import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui";
import { useAppDispatch, useAppSelector } from "@/config/store";
import { IEdoCoursePost } from "@/shared/model/edo-course-post.model";
import { deleteEntity } from "@/shared/reducers/entities/edo-course-post.reducer";
import { EntityState } from "@/shared/reducers/reducer.utils";
import { useEffect } from "react";
import { Translate } from "react-jhipster";

interface IDeleteCoursePostProps {
    post: IEdoCoursePost;
    open: boolean;
    onClose: () => void;
}

const DeleteCoursePostDialog = (props: IDeleteCoursePostProps) => {
    const dispatch = useAppDispatch();
    const { updateSuccess } = useAppSelector<EntityState<IEdoCoursePost>>((state) => state.edoCoursePost);

    const { open, onClose: handleClose, post } = props;

    const confirmDelete = () => {
        dispatch(deleteEntity(post.id));
    };

    useEffect(() => {
        if (updateSuccess) {
            handleClose();
        }
    }, [updateSuccess]);

    return (
        <Dialog open={open} onOpenChange={(open) => !open && handleClose()}>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>
                        <Translate contentKey="entity.delete.title" />
                    </DialogTitle>
                </DialogHeader>
                {!post ? (
                    <div className="flex justify-center py-4">
                        <div className="h-6 w-6 animate-spin rounded-full border-2 border-primary border-t-transparent" />
                    </div>
                ) : (
                    <DialogDescription>
                        <Translate contentKey="edocendoApp.edoCoursePost.delete.question" />
                    </DialogDescription>
                )}
                <DialogFooter>
                    <Button variant="outline" onClick={handleClose}>
                        <Translate contentKey="entity.action.cancel" />
                    </Button>
                    <Button onClick={confirmDelete} variant="default">
                        <Translate contentKey="entity.action.delete" />
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};

export default DeleteCoursePostDialog;